module.exports = __webpack_public_path__ + "img/content-placeholder.3e3e5f18.jpg";